<template>
  <div class="qrCodeBody">
    <Header />
    <div class="qrCodeMain">
      <Step :num='4' authType="1" />
      <div class="infoArea">
        <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="110px" label-position="right">
          <div class="remittanceBox">
            <h3 class="title">对公打款认证<span class="titleStatus" v-if="selectRemittance == 11 ||selectRemittance == 22">验证中</span></h3>
            <div class="remittanceSelectBox">
              <div v-if="businessShow" :class="['remittanceItem', 'el-icon-check',{'active': selectRemittance == 1 ||  selectRemittance == 11}]" @click="selectRemittanceType(1)">
                <p>本平台向贵司对公账户汇入随机金额</p>
                <span>正确回填打款金额，即可完成验证</span>
              </div>
              <div v-if="businessOtherShow" :class="['remittanceItem', 'el-icon-check',{'active': selectRemittance == 2 || selectRemittance == 22}]" @click="selectRemittanceType(2)">
                <p>使用贵司对公账户向本平台汇入指定金额</p>
                <span>平台检测到打款流水后，即可完成验证</span>
              </div>
            </div>
          </div>
          <div class="linede"></div>
          <h3 v-if="selectRemittance == 1" class="title">请输入您的对公账户信息</h3>
          <div v-if="selectRemittance == 1" class="remittanceInfo">
            <el-form-item label="对公账户户名" prop="companyName">
              <el-input disabled v-model="infoForm.companyName" size="small" placeholder="请输入对公账户户名" maxlength="60"></el-input>
            </el-form-item>
            <el-form-item label="对公账户" prop="acctNo">
              <el-input v-model="infoForm.acctNo" size="small" placeholder="请输入对公账户" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="bankName">
              <el-input v-model="infoForm.bankName" size="small" placeholder="请输入开户银行" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="开户银行支行" prop="bankBranch">
              <el-autocomplete v-model="infoForm.bankBranch" :value-key="'branchBankName'" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" @select="handleSelect"></el-autocomplete>
              <!-- <el-input v-model="infoForm.bankBranch" @input="getBank" size="small" placeholder="请输入开户银行支行" maxlength="30"></el-input> -->
            </el-form-item>
          </div>
          <div v-if="selectRemittance == 11" class="comment">本平台已于<span>{{ operationTime }}</span>向您的对公账户汇入一笔随机金额（0.01～1元），具体以到账时间为准，请查看您的对公账户交易流水，并填写随机金额，以完成认证</div>
          <div v-if="selectRemittance == 11" class="remittanceInfo">
            <div class="accountItem">
              <span>对公账户户名：</span>
              <p>深圳法大大网络科技有限公司</p>
            </div>
            <div class="accountItem">
              <span>对公账号：</span>
              <p>7559 2959 7010 903</p>
            </div>
            <div class="accountItem">
              <span>开户银行支行：</span>
              <p>招商银行 深圳分行 深圳软件基地支行</p>
            </div>
            <div class="accountItem">
              <span>打款金额：</span>
              <el-input v-model="infoForm.amount" size="small" placeholder="请输入" maxlength="4"></el-input> 元
            </div>
          </div>
          <div v-if="selectRemittance == 2" class="comment">使用贵公司对公账户向本平台汇入指定金额，在汇款之前，请您详细阅读并确认以下细则：</div>
          <div v-if="selectRemittance == 2" class="remittanceInfo">
            <div class="accountEnterItem">
              <span>汇款方户名必须为当前实名企业：</span>
              <el-input v-model="infoForm.companyName" disabled size="small" placeholder="请输入" maxlength="30"></el-input>
            </div>
            <div class="accountEnterItem">
              <span>汇款方户名必须使用当前企业的对公账户进行汇款</span>
            </div>
            <div class="accountEnterItem">
              <span>汇款方向汇入方汇入单笔金额为0.01元（一分钱）人民币，不能为其他金额或其他币种</span>
            </div>
            <div class="accountEnterItem">
              <span>汇款金额仅作为企业实名专用，不作用其他用途，请勿额外汇款，汇入金额不做退还，无发票凭证</span>
            </div>
          </div>
          <div v-if="selectRemittance == 22" class="comment">使用贵公司对公账户向本平台汇入指定金额，收款方信息如下：</div>
          <div v-if="selectRemittance == 22" class="remittanceInfo">
            <div class="accountItem">
              <span>收款方户名：</span>
              <p>深圳法大大网络科技有限公司</p>
            </div>
            <div class="accountItem">
              <span>收款方账户：</span>
              <p>7559 2959 7010 903</p>
            </div>
            <div class="accountItem">
              <span>收款方开户行：</span>
              <p>招商银行 深圳分行 深圳软件基地支行</p>
            </div>
            <div class="accountItem">
              <span>汇款金额：</span>
              <p>0.01元（1分钱）</p>
            </div>
            <div class="linede"></div>
            <div class="notice"><i class="el-icon-warning"></i> 汇款时效为30天，<span>请于{{ moneyDeadline }}之前完成汇款</span>，否则将验证失败</div>
          </div>
        </el-form>
      </div>
      <div class="lineBtn">
        <el-button v-if="selectRemittance == 1 || selectRemittance == 2" size="mini" @click="getRoute">上一步</el-button>
        <el-button v-if="selectRemittance == 1" type="primary" size="mini" @click="setMakeInfo">提交</el-button>
        <el-button v-if="selectRemittance == 11" type="primary" size="mini" @click="getMakeMoneyVerify">提交验证</el-button>
        <el-button v-if="selectRemittance == 2" type="primary" size="mini" @click="createVerify(false)">同意并开始汇款</el-button>
      </div>
    </div>
    <v-dialog v-if="dialogShow" :title="'验证失败'" :msg="dialogMsg" :msgNote="dialogMsgNote" @getDialogClose="getDialogClose"></v-dialog>
  </div>
</template>

<script>
import dialog from '../../components/common/dialog.vue'
export default {
  data() {
    return {
      isScanning: false,
      dialogShow: false,
      dialogMsg: '打款金额校验不一致，请确定后重新输入',
      dialogMsgNote: 2,
      operationTime: '',
      infoForm: {
        companyName: '',
        acctNo: '',
        bankName: '中国农业银行',
        bankBranch: '',
        amount: undefined
      },
      rules: {
        acctNo: [
          { required: true, message: '请输入对公账户', trigger: 'blur' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的对公账户',
            trigger: 'blur'
          }
        ],
        bankName: [
          { required: true, message: '请输入开户银行', trigger: 'blur' }
        ],
        bankBranch: [
          { required: true, message: '请输入开户银行支行', trigger: 'blur' }
        ]
      },
      selectRemittance: 1,
      pic: 0,
      makeMoneyMode: 0,
      moneyDeadline: '',
      businessShow: false,
      businessOtherShow: false
    }
  },
  mounted() {
    this.getInfo()
    this.getData = this.debounce(this.getBankData, 500)
  },
  components: {
    'v-dialog': dialog
  },
  methods: {
    querySearchAsync(queryString, cb) {
      // var results = [  { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" }]
      if (this.infoForm.bankName) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$api
            .getBank({
              bankName: this.infoForm.bankName,
              keyWord: this.infoForm.bankBranch
            })
            .then(res => {
              cb(res.data)
            })
        }, 2000 * Math.random())
      } else {
        cb([
          {
            bankName: '中国银行',
            branchBankCode: '104100000004',
            branchBankName: '中国银行总行'
          }
        ])
      }
    },
    getDialogClose() {
      if (Number(this.dialogMsgNote) === 0) {
        this.$api
          .getBackStep({ flowId: this.$store.state.userInfo.flowId })
          .then(res => {
            if (res.code && res.code === '0') {
              this.$router.push({ name: 'companyEntryInfo' })
            } else {
              return new Promise((resolve, reject) => {
                reject(res)
              })
            }
          })
          .catch(err => {
            this.dialogShow = false
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {
                this.$router.push({ name: 'companyEntryInfo' })
              }
            })
          })
      } else {
        this.dialogShow = false
      }
    },
    handleSelect() {
      this.$refs['infoForm'].clearValidate()
    },
    getInfo() {
      this.$api
        .getInfo({
          flowId: this.$store.state.userInfo.flowId
        })
        .then(res => {
          this.$set(this.infoForm, 'companyName', res.data.companyName)
          this.operationTime = res.data.operationTime
          let authMode = res.data.availableAuthType.split(',')
          authMode.forEach(v => {
            if (v === 'ENTERPRISE_BUSINESS_MAKE') {
              //对公打款
              this.businessShow = true
            }
            if (v === 'ENTERPRISE_BUSINESS_MAKE_OTHER') {
              //对公打款-对方打
              this.businessOtherShow = true
            }
          })
          this.selectRemittance = this.businessShow === false ? 2 : 1
          this.makeMoneyMode = res.data.makeMoneyMode //选择对公打款类型
          if (this.makeMoneyMode) {
            this.selectRemittance = this.makeMoneyMode == 1 ? 11 : 22
            this.makeMoneyMode === '2' ? this.getMakeMoneyDeadline() : null
          }

          if (res.code !== '0') {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '810404') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          } else if (err.code !== '302') {
            // this.sendCode({code: -1,msg:  err.msg})
            // this.verifyMsg =  err.msg || '认证失败'
            // this.authCompletedShow = true
          }
        })
    },
    getMakeMoneyDeadline() {
      this.$api
        .getMakeMoneyDeadline({
          flowId: this.$store.state.userInfo.flowId
        })
        .then(res => {
          if (res.code && res.code === '0') {
            this.moneyDeadline = res.data
          }
        })
        .catch()
    },
    setMakeInfo() {
      let data = {
        flowId: this.$store.state.userInfo.flowId,
        companyName: this.infoForm.companyName,
        acctNo: this.infoForm.acctNo,
        bankName: this.infoForm.bankName,
        bankBranch: this.infoForm.bankBranch
      }
      this.$refs['infoForm'].validate(valid => {
        if (valid) {
          this.$api
            .setMakeInfo(data)
            .then(res => {
              if (res.code && res.code === '0') {
                this.createVerify(true)
              } else {
                return new Promise((resolve, reject) => {
                  reject(res)
                })
              }
              // this.infoForm.bankBranch = res.data.bankBranch
            })
            .catch(err => {
              this.$alert(err.msg, '提示', {
                confirmButtonText: '好的',
                callback: () => {}
              })
            })
        }
      })
    },
    createVerify(item) {
      this.$api
        .createVerify({
          flowId: this.$store.state.userInfo.flowId,
          mode: 4,
          ourMakeMoney: item || false
        })
        .then(res => {
          if (res.code && res.code === '0') {
            if (item) {
              this.selectRemittance = 11
            } else {
              this.selectRemittance = 22
              this.pic = res.data.amount
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.$alert(err.msg, '提示', {
            confirmButtonText: '好的',
            callback: () => {}
          })
        })
    },
    getMakeMoneyVerify() {
      let data = {
        flowId: this.$store.state.userInfo.flowId,
        amount: this.infoForm.amount
      }
      let reg = /(^([0]\.\d{1,2})?$)/
      this.infoForm.amount =
        this.infoForm.amount === '' ? undefined : this.infoForm.amount
      if (
        reg.test(this.infoForm.amount) ||
        Number(this.infoForm.amount) === 1
      ) {
        this.$api
          .getMakeMoneyVerify(data)
          .then(res => {
            if (res.code && res.code === '0') {
              this.$router.push({ name: 'authSuccess' })
            } else {
              return new Promise((resolve, reject) => {
                reject(res)
              })
            }
            // this.infoForm.bankBranch = res.data.bankBranch
          })
          .catch(err => {
            this.infoForm.amount = ''
            if (err.code === '810411' || err.code === '810408') {
              //810411打款金额不一致
              this.dialogShow = true
              this.dialogMsg = err.msg
              this.dialogMsgNote = err.data.remainTimes
            } else if (err.code === '810412' || err.code === '810415') {
              //认证流程结束 810412'对公打款调用失败，银行打款失败 810415该认证流程已失效,请重新发起认证
              this.$alert(err.msg, '验证失败', {
                confirmButtonText: '好的',
                callback: () => {
                  window.location.href = this.$store.state.userInfo.preWebUrl
                }
              })
              // } else if (err.code === '810408') {
              //   // 810408三次机会用完
              //   this.$alert(err.msg, '验证失败', {
              //     confirmButtonText: '好的',
              //     callback: () => {
              //       this.$router.push({ name: 'companyEntryInfo' })
              //     }
              // })
            } else {
              this.$alert(err.msg, '验证失败', {
                confirmButtonText: '好的',
                type: 'warning'
              })
            }
          })
      } else {
        this.$alert('请输入对公账户收到的打款金额！（0.01～1元）', '提示', {
          confirmButtonText: '好的',
          type: 'warning'
        })
      }
    },
    selectRemittanceType(item) {
      if (
        (this.selectRemittance === 11 && item === 1) ||
        (this.selectRemittance === 22 && item === 2)
      ) {
        return false
      }
      this.selectRemittance = item
      if (this.makeMoneyMode === 0) {
        this.selectRemittance = item
      }
    },
    getBankData() {
      return this.$api
        .getBank({
          bankName: this.infoForm.bankName,
          keyWord: this.infoForm.bankBranch
        })
        .then(res => {
          return res.data.bankBranch
        })
    },
    getBank() {
      this.getData()
    },
    debounce(fn, delay) {
      let timer = null
      return function() {
        let context = this
        let args = arguments
        if (timer) {
          clearTimeout(timer)
        }
        // 设立新定时器
        timer = setTimeout(function() {
          fn.apply(context, args)
        }, delay)
      }
    },
    getRoute() {
      if (this.$store.state.userInfo.havaAgentAuth) {
        this.$router.push({ name: 'companyAgentScanningCode' })
      } else {
        this.$router.push({ name: 'companyEntryInfo' })
      }
    },
    getResult() {
      this.$alert('未查到人脸结果，请扫描二维码并完成人脸识别！', '提示', {
        confirmButtonText: '好的',
        type: 'warning'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qrCodeBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.qrCodeMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.qrCode {
  width: max-content;
  margin: 64px auto 0;
  display: flex;
}
.remittanceBox {
  width: 680px;
  margin: auto;
}
.infoArea {
  width: 680px;
  margin: 51px auto 0px;
  padding-bottom: 60px;
  .title {
    font-weight: 500;
    font-size: 14px;
    color: #303b50;
    line-height: 19px;
    margin-bottom: 16px;
    .titleStatus {
      margin-left: 10px;
      display: inline-block;
      width: 50px;
      height: 20px;
      font-size: 12px;
      text-align: center;
      color: #eea21f;
      background: #fff4e0;
      border-radius: 1px;
    }
  }
  .comment {
    color: #929292;
    line-height: 22px;
    letter-spacing: 1px;
    font-size: 14px;
    padding-bottom: 32px;
    span {
      color: #303b50;
    }
  }
  .linede {
    border-top: 1px dashed #c4cad1;
    margin: 32px 0;
    width: 100%;
  }
  .notice {
    color: #929292;
    line-height: 19px;
    font-size: 14px;
    span {
      color: #f46b5c;
    }
    .el-icon-warning {
      color: #e89e1c;
      font-size: 16px;
    }
  }
  .remittanceSelectBox {
    display: flex;
    justify-content: space-between;
    .remittanceItem {
      // width: 326px;
      // height: 126px;
      position: relative;
      background: #ffffff;
      border-radius: 4px;
      box-sizing: content-box;
      border: 1px solid #d5dbe2;
      padding: 21px 112px 21px 24px;
      cursor: pointer;
      &::before {
        position: absolute;
        right: 1px;
        top: 1px;
        z-index: 2;
        font-size: 12px;
        color: #fff;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        width: 0;
        height: 0;
        line-height: 0;
        font-size: 0;
        border-top: 0px solid transparent;
        border-right: 26px solid #d5dbe2;
        border-bottom: 26px solid transparent;
        border-left: 0px solid transparent;
      }
      &.active {
        border: 1px solid #1c67f3;
        &::after {
          border-right: 26px solid #1c67f3;
        }
      }
      p {
        width: 190px;
        font-size: 16px;
        color: #333333;
        line-height: 26px;
        padding-bottom: 12px;
      }
      span {
        font-size: 12px;
        color: #929292;
        line-height: 16px;
      }
    }
  }
  .remittanceInfo {
    padding: 23px;
    background: #f5f7fb;
    .accountItem {
      span {
        color: #929292;
        line-height: 36px;
        font-size: 14px;
      }
      p {
        display: inline-block;
        color: #333333;
        line-height: 36px;
        font-size: 14px;
      }
      .el-input {
        width: 94px;
      }
    }
    .accountEnterItem {
      position: relative;
      padding-left: 6px;
      &::before {
        position: absolute;
        left: -7px;
        top: 15px;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: #d4d4d5;
      }
      span {
        color: #666;
        line-height: 36px;
        font-size: 14px;
      }
      .el-input {
        width: 400px;
      }
    }
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    ::v-deep span {
      color: #1c67f3;
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
  .verifyType {
    ::v-deep.el-radio-button__inner {
      width: 158px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d5dbe2;
      margin-right: 16px;
    }
    .el-radio-button.is-active {
      ::v-deep.el-radio-button__inner {
        color: #1c67f3;
        border: 1px solid #1c67f3;
        box-shadow: none;
      }
    }
  }
}
.lineBtn {
  width: 1600px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eceef1;
  padding: 12px 0;
  text-align: center;
}
.el-autocomplete {
  width: 100%;
  ::v-deep.el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}
</style>